import { unitOfTime } from 'moment';
import React, { useMemo } from 'react';
import { DateUtils } from '../../utils/date.utils';
import { Tooltip } from '../labels';
import { DateView } from './DateView';
import styled from 'styled-components';

function TooltipTemplate({
    from,
    to,
    options,
}: {
    from: Date | string | null | undefined;
    to?: Date | string | null | undefined;
    options: DurationViewTooltipOptions;
}) {
    return (
        <div className="duration-view-tooltip">
            <div className="tooltip-row">
                <div className="tooltip-row-title">{options.fromLabel}</div>
                <DateView value={from} format={{ milliseconds: true }} />
            </div>
            {to && (
                <div className="tooltip-row">
                    <div className="tooltip-row-title">{options.toLabel}</div>
                    <DateView value={to} format={{ milliseconds: true }} />
                </div>
            )}
        </div>
    );
}

export type DurationViewTooltipOptions = { fromLabel?: string; toLabel?: string };

const Styles = styled.div.attrs((props) => ({ className: 'app-duration-view' }))`
    &.app-duration-view {
    }
`;

export type DurationViewProps = {
    from: Date | string | null | undefined;
    to?: Date | string | null | undefined;
    units?: unitOfTime.Base | unitOfTime.Base[];
    emptyText?: string;
    tooltip?: boolean | DurationViewTooltipOptions;
    className?: string;
};

function DurationViewImpl({ from, to, units, emptyText, tooltip, className }: DurationViewProps) {
    const formatted = useMemo(
        () =>
            DateUtils.formatDuration(from, to, {
                units,
                emptyText,
            }),
        [from, to, units, emptyText],
    );

    const tooltipOptions =
        tooltip && typeof tooltip === 'object'
            ? tooltip
            : {
                  fromLabel: 'From',
                  toLabel: 'To',
              };

    const tooltipEnabled = tooltip && (from || to);

    const ContentWrap = ({ children }) =>
        tooltipEnabled ? (
            <Tooltip
                anchorElement="target"
                position="bottom"
                content={() => <TooltipTemplate from={from} to={to} options={tooltipOptions} />}
            >
                {children}
            </Tooltip>
        ) : (
            children
        );

    return (
        <Styles
            className={`app-duration-view ${className || ''}`}
            style={{ cursor: tooltipEnabled ? 'pointer' : 'inherit' }}
        >
            <ContentWrap>
                <span className="duration-value" title={tooltipEnabled ? 'tooltip-trigger' : undefined}>
                    {formatted}
                </span>
            </ContentWrap>
        </Styles>
    );
}

export const DurationView = styled(DurationViewImpl)``;
